import { PlayerPortalsBurgerMenu } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => PlayerPortalsBurgerMenu,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.Menu) =>
    kontentAiDataMapping.player_portals_menu(entry),
  depthParameter: 10,
};
